import { BACKEND_URL } from "../config/Constant";
import api from "../utils/axiosInstance";
const API = "call";

export const getCallHistory = async(datas) => {
  console.log("Datass",datas)
  const data={
page:datas
  }
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/callhistory`, data);
      return response;
    } catch (error) {
      return error;
    }
  };

  
export const getCallHistoryDetail = async (data) => {
    const id={
        callID:data
    }
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/calldetails`, id);
      return response;
    } catch (error) {
      return error;
    }
  };